'use client'
import {
  CATEGORY_QUERY
} from "./chunk-ZZ3DUO5U.mjs";
import {
  gqlClient
} from "./chunk-6XSQRWIQ.mjs";
import {
  __async,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/api/categories/listing.ts
import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";
import { Exception } from "@wbk/logger";
var getCategories = (props) => __async(void 0, null, function* () {
  try {
    const res = yield gqlClient.request(
      gql`
        query getCategories($lang: String, $limit: Int, $skip: Int, $where: CategoryFilter) {
          categoryCollection(locale: $lang, limit: $limit, skip: $skip, where: $where) {
            items {${CATEGORY_QUERY}}
          }
        }
      `,
      __spreadValues({ order: "order_ASC" }, props)
    );
    return res.categoryCollection.items;
  } catch (error) {
    throw new Exception({ error, name: "getCategoriesException" });
  }
});
var useGetCategories = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getCategories", props],
    queryFn: () => getCategories(props)
  }, options));
};

export {
  useGetCategories
};
//# sourceMappingURL=chunk-HKGNX5TB.mjs.map